// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"323":"User","987":"SendList"}[chunkId] + "." + {"323":"8e752a8b","987":"8e752a8b"}[chunkId] + ".chunk.css";
};